import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type { AuditLog, AuditLogsPayload } from './types';

export const AuditService = {
    getAuditLogs: async (payload: AuditLogsPayload): Promise<ApiResponse<PaginatedResponse<AuditLog>>> => {
        const response = await apiClient.post('/AuditLogs/GetAuditLogs', {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            entityName: payload.entityName,
            correlationId: payload.correlationId,
            userName: payload.userName,
            from: payload.from,
            to: payload.to,
            action: payload.action
        });
        return response.data;
    },
};
